import React, { useContext, useEffect, useRef, useState } from 'react';
import '../DataSet/DataSet.css';
import { MainContext } from '../ContextStore/MainContext';
import './HackathonWinners.css'
import { FaLinkedin } from "react-icons/fa";


// Importing images
import Arvind from './HackthonWinnersPhotos/Hackathon-1/1.Arvind Badagi.jpg';
import Harshita from './HackthonWinnersPhotos/Hackathon-1/2.Harshita Aswani.jpg';
import Pallavi from './HackthonWinnersPhotos/Hackathon-1/2.Pallavi Patil.jpg';
import Srividya from './HackthonWinnersPhotos/Hackathon-1/3.Srividya K.jpg';

import Fareeha from './HackthonWinnersPhotos/Hackathon-2/1. Fareeha Ali.png';
import Vidya from './HackthonWinnersPhotos/Hackathon-2/2.Vidya Divakar.jpg';
import Divya from './HackthonWinnersPhotos/Hackathon-2/3. Divya Kanchi.jpg';

import Parthiban_Chinnasamy from './HackthonWinnersPhotos/Hackathon-3/Parthiban Chinnasamy-1st.png';
import Magudeswaran_M from './HackthonWinnersPhotos/Hackathon-3/Magudeswaran M-2nd.png';
import Premkumar_Sekar from './HackthonWinnersPhotos/Hackathon-3/Premkumar Sekar-3rd.png';

export default function HackathonWinners() {
    const { selectedHackathon } = useContext(MainContext);
    const [HackathonWinnersData, setHackathonWinnersData] = useState([]);

    const [isMouseDown, setIsMouseDown] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
    const containerRef = useRef(null);

    const onMouseDown = (e) => {
        setIsMouseDown(true);
        setStartX(e.clientX - containerRef.current.offsetLeft);
        setScrollLeft(containerRef.current.scrollLeft);
    };

    const onMouseLeave = () => {
        setIsMouseDown(false);
    };

    const onMouseUp = () => {
        setIsMouseDown(false);
    };

    const onMouseMove = (e) => {
        if (!isMouseDown) return;
        const x = e.clientX - containerRef.current.offsetLeft;
        const walk = (x - startX) * 2; // Scroll speed multiplier
        containerRef.current.scrollLeft = scrollLeft - walk;
    };

    const hackathonOneWinners = [
        {
            image: Arvind,
            name: 'Arvind Badagi',
            rank: 1,
            linkedinURL: "https://www.linkedin.com/posts/arvindbadagi_powerbi-dataanalytics-restaurantindustry-activity-7252998293536813056-a2do?utm_source=share&utm_medium=member_desktop&rcm=ACoAAFG3RRYBthf6qzzfJ5RHXmPBmLOd90VxYYU"
        },
        {
            image: Harshita,
            name: 'Harshita Aswani',
            rank: 2,
            linkedinURL: "https://www.linkedin.com/posts/harshita-aswani_data-datascience-dataanalysis-activity-7249388077645770753-l65X?utm_source=share&utm_medium=member_desktop&rcm=ACoAAFG3RRYBthf6qzzfJ5RHXmPBmLOd90VxYYU"
        },
        {
            image: Pallavi,
            name: 'Pallavi Patil',
            rank: 2,
            linkedinURL: "https://www.linkedin.com/posts/pallavi-patil-174651255_im-excited-to-share-the-hackathon-project-activity-7253037236185665537-48-Z?utm_source=share&utm_medium=member_desktop&rcm=ACoAAFG3RRYBthf6qzzfJ5RHXmPBmLOd90VxYYU"
        },
        {
            image: Srividya,
            name: 'Srividya K',
            rank: 3,
            linkedinURL: "https://www.linkedin.com/posts/srividyakinjingi_santhosh-activity-7248406192467664896-PIjl?utm_source=share&utm_medium=member_desktop&rcm=ACoAAFG3RRYBthf6qzzfJ5RHXmPBmLOd90VxYYU"
        }
    ];

    const hackathonTwoWinners = [
        {
            image: Fareeha,
            name: 'Fareeha Ali',
            rank: 1,
            linkedinURL: "https://www.linkedin.com/feed/update/urn:li:activity:7285825912913252353?utm_source=share&utm_medium=member_desktop&rcm=ACoAAFG3RRYBthf6qzzfJ5RHXmPBmLOd90VxYYU"
        },
        {
            image: Vidya,
            name: 'Vidya Divakar',
            rank: 2,
            linkedinURL: "https://www.linkedin.com/posts/vidya-divakar_powerbi-datavisualization-boxofficeanalysis-activity-7285579227750440961-Tuth/?utm_source=share&utm_medium=member_desktop"
        },
        {
            image: Divya,
            name: 'Divya Kanchi',
            rank: 3,
            linkedinURL: "https://www.linkedin.com/feed/update/urn:li:activity:7285086503007854593/?utm_source=share&utm_medium=member_desktop"
        }
    ];

     const hackathonThreeWinners = [
        {
            image: Parthiban_Chinnasamy,
            name: 'Parthiban Chinnasamy',
            rank: 1,
            linkedinURL: "https://www.linkedin.com/in/parthiban-chinnasamy-586bbb76/"
        },
        {
            image: Magudeswaran_M,
            name: 'Magudeswaran ',
            rank: 2,
            linkedinURL: "https://www.linkedin.com/in/magudeswaranm/"
        },
        {
            image: Premkumar_Sekar,
            name: 'Premkumar Sekar',
            rank: 3,
            linkedinURL: "https://www.linkedin.com/in/prem-kumar-sekar-3b1852103/"
        }
    ];

    useEffect(() => {
        setHackathonWinnersData(selectedHackathon === 'hackathon1' ? hackathonOneWinners : selectedHackathon === 'hackathon2' ? hackathonTwoWinners : hackathonThreeWinners);
        // eslint-disable-next-line
    }, [selectedHackathon]);

    return (
        <div>
            <p className='hackathonNameHeading'>{selectedHackathon==="hackathon1"?"Hackathon-1 Winners":selectedHackathon==="hackathon2"?"Hackathon-2 Winners":"Hackathon-3 Winners"}</p>
            <div className='allDatasets allWinners' ref={containerRef}
                onMouseDown={onMouseDown}
                onMouseLeave={onMouseLeave}
                onMouseUp={onMouseUp}
                onMouseMove={onMouseMove}>
                {
                    HackathonWinnersData?.map((winner, id) => (
                        <div key={id} className='eachWinner'>
                            <img src={winner.image} alt={winner.name} className='winnerImage'></img>
                            <p className='winnerName'>{winner.name} <FaLinkedin className='linkedinIcon' onClick={()=>{
                                window.open(winner.linkedinURL, '_blank')
                            }}/></p>
                            <p className='winnerRank'>Rank: {winner.rank}</p>
                            
                            {/* <a href={winner.linkedinURL} target="_blank" rel="noreferrer" className='winnerLinkedin'>LinkedIn</a> */}
                        </div>
                    ))
                }
            </div>
        </div>
    );
}
